const getters = {
  getCodecList(state) {
    return state.codecs;
  },
};
export default getters;
